export const requestsTableName = 'REQUESTS'
